
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Wrapper from "../UI/Wrapper";
import "../../components/LeadExpenseList/LeadExpenseList.css";


function ExpenseList({ relocationId, onClose }) {
  const [expense_Type, setExpense_Type] = useState([]);
  const baseAPI = process.env.REACT_APP_API_URL;
  const fileInputRef = useRef(null);
  const [vendorList, setVendorList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [paymentMode, setPaymentMode] = useState([]);
  const [pettyCashMaster, setPettyCashMaster] = useState([]);

  const storedToken = JSON.parse(localStorage.getItem("token"));
  const [updatedFormData, setUpdatedFormData] = useState({
    Relocation_Id: relocationId,
    Description: "",
    Expense_Type: "",
    Job_Id: null,
    Document: "",
    Created_By: "",
    Created_Date: "",
    expense_date: "",
    vendor_id: "0",
    location: "0",
    rate: "",
    quantity: "",
    expense_amount: "",
    expense_category: "0",
    payment_mode: "0",
    expense_made_for: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!updatedFormData.expense_amount || updatedFormData.Expense_Type === "0") {
      alert("Please enter Amount and select an Expense Type.");
      return;
    }

    if (!updatedFormData.vendor_id || updatedFormData.vendor_id === "0") {
      alert("Please select a Vendor.");
      return;
    }

    if (!updatedFormData.location || updatedFormData.location === "0") {
      alert("Please select a Location.");
      return;
    }




    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      try {
        const response = await axios.post(
          `${baseAPI}Userpost/AddFieldOpsExpense?ExpenseId=0`,
          updatedFormData,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );
        alert("Expense successfully added");
        setUpdatedFormData({
          ...updatedFormData,
          Description: "",
          Expense_Type: "",
          Job_Id: null,
          Document: "",
          Created_By: "",
          Created_Date: "",
          expense_date: "",
          vendor_id: "0",
          location: "0",
          rate: "",
          quantity: "",
          expense_amount: "",
          expense_category: "0",
          payment_mode: "0",
          expense_made_for: "",
        });
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        onClose();
      } catch (error) {
        console.error("Error posting data:", error);
      }
    }
  };

  const handleChange = (type, e) => {
    const { name, value, files } = e.target;

    if (type === "get") {
      getExpenseTypeList();
      return;
    }

    if (name === "Document") {
      const file = files[0];
      getUpdatedDocument(file, name);
      return;
    }

    // Create a shallow copy to update
    let updatedForm = {
      ...updatedFormData,
      [name]: value,
    };

    // If Expense_Type changes, update expense_category as well
    if (name === "Expense_Type") {
      const selectedExpense = expense_Type.find(
        (exp) => exp.expense_description_id.toString() === value
      );
      if (selectedExpense) {
        updatedForm.expense_category = selectedExpense.expense_category_id || "0";
      }
    }
    if (name === "expense_date") {
      const selectedDate = new Date(value);
      const today = new Date();
      today.setHours(0, 0, 0, 0); // remove time part for accurate comparison
      selectedDate.setHours(0, 0, 0, 0);
      if (selectedDate > today) {
        alert("Future dates are not allowed.");
        console.log(today, selectedDate);
        return;
      }
    }

    // Recalculate expense_amount if rate or quantity changes
    if (name === "rate" || name === "quantity") {
      const rate = parseFloat(name === "rate" ? value : updatedFormData.rate) || 0;
      const quantity = parseFloat(name === "quantity" ? value : updatedFormData.quantity) || 0;
      updatedForm.expense_amount = (rate * quantity).toFixed(2);
    }

    setUpdatedFormData(updatedForm);
  };

  function getUpdatedDocument(file, name) {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const imageData = reader.result;
        setUpdatedFormData({
          ...updatedFormData,
          [name]: imageData,
        });
      };
      reader.readAsDataURL(file);
    }
  }


  function handleReset() {
    setUpdatedFormData({
      ...updatedFormData,
      Description: "",
      Expense_Type: "",
      Job_Id: null,
      Document: "",
      Created_By: "",
      Created_Date: "",
      expense_date: "",
      vendor_id: "0",
      location: "0",
      rate: "",
      quantity: "",
      expense_amount: "",
      expense_category: "0",
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    onClose();
  }


  const getExpenseTypeList = async () => {
    try {
      if (storedToken) {
        const response = await axios.get(`${baseAPI}adminGet/GetExpenseDescriptions?expense_type=1&expense_category=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        });
        setExpense_Type(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching expense type list:", error);
    }
  };

  const getVendorList = async () => {
    try {
      if (storedToken) {
        const response = await axios.get(`${baseAPI}adminGet/GETSupplier?SupplierID=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        });
        setVendorList(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching expense type list:", error);
    }
  };

  const getPaymentMode = async () => {
    try {
      if (storedToken) {
        const response = await axios.get(`${baseAPI}adminGet/GetPaymentMode`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        });
        setPaymentMode(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching expense type list:", error);
    }
  };




  const getLocationList = async () => {
    try {
      if (storedToken) {
        const response = await axios.get(`${baseAPI}adminGet/GetLocations`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        });
        setLocationList(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching expense type list:", error);
    }
  };

  const getpaymentMadeFor = async () => {
    try {
      if (storedToken) {
        const response = await axios.get(`${baseAPI}adminGet/GetPettyCashMaster`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        });
        setPettyCashMaster(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching expense type list:", error);
    }
  };



  useEffect(() => {
    getExpenseTypeList();
    getVendorList();
    getLocationList();
    getPaymentMode();
    getpaymentMadeFor();
  }, []);

  return (
    <>
      <div className="d-flex flex-row app">
        <div
          className="container-fluid respDiv"
          style={{ padding: "0rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div>
              <Wrapper className="ViewLeadDetails">
                <div className="bg-white shadow-md rounded-lg max-w-4xl mx-auto">
                  <div className="row mb-3">
                    <div className="col-3">
                      <label className="form-label">Date of Expense</label>
                      <input type="date" class="form-control form-control-expencsems" name="expense_date" onChange={(event) => handleChange("insert", event)} value={updatedFormData.expense_date} max={new Date().toISOString().split("T")[0]} />
                    </div>
                    <div className="col-6">
                      <label className="form-label">Vendor Name</label>
                      <select class="form-control form-control-expencsems" name="vendor_id" onChange={(event) => handleChange("insert", event)} value={updatedFormData.vendor_id}>
                        <option value="0" >Select</option>
                        {vendorList.map((exp) => (
                          <option key={exp.Vendor_Id} value={exp.Vendor_Id}>
                            {exp.VendorFirstName} {exp.VendorLastName}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-3">
                      <label className="form-label">Location</label>
                      <select class="form-control form-control-expencsems" name="location" onChange={(event) => handleChange("insert", event)} value={updatedFormData.location} >
                        <option value="0" >Select</option>
                        {locationList.map((location) => (
                          <option key={location.location_id} value={location.location_id}>
                            {location.location}
                          </option>
                        ))}
                      </select>
                    </div>



                  </div>
                  <div className="row mb-3">
                    <div class="col-md-4">
                      <label className="form-label">Rate</label>
                      <input type="text" class="form-control form-control-bills" placeholder="Enter" name="rate" onChange={(event) => handleChange("insert", event)} value={updatedFormData.rate} />
                    </div>
                    <div class="col-md-4">
                      <label className="form-label">Quantity</label>
                      <input type="text" class="form-control form-control-bills" placeholder="Enter" name="quantity" onChange={(event) => handleChange("insert", event)} value={updatedFormData.quantity} />
                    </div>
                    <div class="col-md-4">
                      <label className="form-label">Expense Amount</label>
                      <input type="text" class="form-control form-control-bills" placeholder="Enter" name="expense_amount" onChange={(event) => handleChange("insert", event)} value={updatedFormData.expense_amount} />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-4">
                      <label className="form-label">Expense Description</label>
                      <select className="form-control" name="Expense_Type" onChange={(event) => handleChange("insert", event)} required value={updatedFormData.Expense_Type}   >
                        <option value="0">Select an option</option>
                        {expense_Type !== null
                          ? expense_Type.map((exp) => (
                            <option key={exp.expense_description_id} value={exp.expense_description_id}>
                              {exp.description}
                            </option>
                          ))
                          : null}
                      </select>
                    </div>
                    <div className="col-4">
                      <label className="form-label">Receipt No.</label>
                      <input
                        type="text"
                        className="form-control form-control-bills"
                        placeholder="Enter"
                        name="Job_Id"
                        onChange={(event) => handleChange("insert", event)}
                        value={updatedFormData.Job_Id}
                        required
                      />
                    </div>
                    <div className="col-4">
                      <label className="form-label">Choose Document</label>
                      <input type="file" class="form-control form-control-expencsems"
                        name="Document"
                        ref={fileInputRef}
                        onChange={(event) => handleChange("insert", event)}
                        placeholder="Please Enter*"
                        required

                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-4">
                      <label className="form-label">Payment Mode</label>
                      <select class="form-control form-control-expencsems" name="payment_mode" onChange={(e) => handleChange("insert", e)} value={updatedFormData.payment_mode}  >
                        <option value="0" >Select</option>
                        {paymentMode.map((exp) => (
                          <option key={exp.payment_mode_id} value={exp.payment_mode_id}>
                            {exp.payment_mode}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-4">
                      <label className="form-label">Expense Made by</label>
                      <select class="form-control form-control-expencsems" name="expense_made_for" onChange={(e) => handleChange("insert", e)} value={updatedFormData.expense_made_for}  >
                        <option value="0" >Select</option>
                        {pettyCashMaster.map((exp) => (
                          <option key={exp.employee_id} value={exp.employee_id}>
                            {exp.Name}
                          </option>
                        ))}

                      </select>
                    </div>
                    <div className="col-4">
                      <label className="form-label">Remark</label>
                      <input
                        type="text"
                        className="form-control form-control-bills"
                        name="Description"
                        onChange={(event) => handleChange("insert", event)}
                        value={updatedFormData.Description}
                        placeholder="Please Enter*"
                        required
                      />
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-12" style={{ direction: "rtl" }}  >
                      <button
                        onClick={handleSubmit}
                        type="submit"
                        style={{
                          marginRight: "4px",
                          backgroundColor: "#5B489D",
                          color: "white",
                          width: "7rem",
                          height: "2.5rem",
                          fontSize: "12px",
                        }}
                      >
                        Add Expense
                      </button>
                      <button
                        onClick={handleReset}
                        style={{
                          backgroundColor: "#F15843", color: "white", width: "7rem",
                          height: "2.5rem",
                          fontSize: "12px",
                        }}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </Wrapper>
            </div>
          </div>
        </div>
      </div >
    </>
  );
}

export default ExpenseList;
